export interface SimpleReportToolbarProps {}

const SimpleReportToolbar: React.FC<SimpleReportToolbarProps> = ({}) => {
  return null;
};
export default SimpleReportToolbar;
